<template>
  <div class="container">
    <img src="@/assets/img/ic_back.png" class="back-btn" alt @click="onBackClicked" />
    <!--v-show="step<5"-->
    <div class="pass-btn" v-show="!isNeed" @click="nextStep">
      <span>跳过</span>
      <img src="@/assets/img/ic_next.png" alt />
    </div>
    <div class="step-block">
      <div class="step">
        <span class="content" :style="{width:(step/6)*100+'%'}"></span>
      </div>
    </div>
    <div class="block" v-for="(item,index) in surveyList" :key="index" v-if="step===index+1">
      <p class="title">{{item.title}}<span class="title-tip" v-show="item.need">(必填)</span></p>
      <p class="sub-title">魔方屋为您定制专属梦想家园</p>
      <div class="options-block" :class="'options-block-'+step">
        <div
          class="item"
          v-for="(i,j) in item.options"
          :key="j"
          :class="{active:i.selected}"
          @click="i.selected=!i.selected">
          <div v-if="step>3" class="icon-box">
            <img :src="i.selected?i.active_icon:i.icon" class="icon" alt="">
          </div>
          <span>{{i.label}}</span>
        </div>
      </div>
    </div>
    <div class="back-block">
      <img src="@/assets/img/ic_next2.png" class="next-btn" alt @click="onNextClicked"/>
      <img v-if="step===1" src="@/assets/img/pic_background_1.png" class="back-img back-img-1" alt/>
      <img v-else-if="step===2" src="@/assets/img/pic_background_2.png" class="back-img back-img-2" alt/>
      <img v-else-if="step===3" src="@/assets/img/pic_background_3.png" class="back-img back-img-3" alt />
      <img v-else-if="step===4" src="@/assets/img/pic_background_4.png" class="back-img back-img-4" alt/>
      <img v-else-if="step===5" src="@/assets/img/pic_background_5.png" class="back-img back-img-5" alt/>
      <img v-else-if="step===6" src="@/assets/img/pic_background_6.png" class="back-img back-img-6" alt/>
    </div>
  </div>
</template>

<script>
import { getSurveyQuestion,submitSurveyData} from '@/api/api.js';
import { Toast } from 'mint-ui';
import store from "../../vuex/store"
import {getUserBuildingData} from "../../api/api"
import utils from "../../jslib/utils"
export default {
  data() {
    return {
      step: 1,
      disabled:false,
      surveyList: [],
      isNeed: true,
      jumpToLocation: false, // 跳转到填地址

      platform: utils.getPlatform()
    };
  },
  store,
  props: {},
  components: {},
  created(){
    // this.network().getData();
    this.setToken()
    this.surveyList = this.$store.state.surveyList
    this.nextToIndex = this.$route.query.next_to_index
  },
  mounted() {
    this.hideMyHomeInsidePageHead({hideFrom:['/survey']}) // 从“我家”进入时隐藏头部
  },
  methods: {
    nextStep(){
      if(this.nextToIndex){
        this.toIndex()
      }else if(utils.getEnv() === 'web'){
        this.toMyHome()
      }else{
        this.backMainActivity()
      }
    },
    onBackClicked() {
      if (this.step === 1) {
        this.navigateBack();
        return;
      }
      this.step -= 1;
    },
    onNextClicked(){

      let arr = [];
      let isFinishSurvey = 1               // 是否完成了所有必填项
      let currentQuestionFinished = false  // 是否完成了当前必填项问卷

      // 未完成当前必填项问卷不能进行“下一步”
      let quest = this.surveyList[this.step-1]
      if(quest.need){
        quest.options.forEach(i => {
          if(i.selected) currentQuestionFinished = true
        })
      }
      if(!currentQuestionFinished && quest.need){
        this.$uihelper.toast('必填项需填写')
        return
      }

      // 是否完成了所有必填项
      this.surveyList.forEach(item=>{
        let haveVal = false
        item.options.forEach(i=>{
          if(i.selected){
            arr.push(i.label)
            haveVal = true
          }
        })
        if(item.need && !haveVal && isFinishSurvey != 0){
          isFinishSurvey = 0
        }
      })

      // finished: 判断是否完成必填项 0-必填项未填写完整，1-必填项已填写完整
      this.network().submitData({ids: arr, finished: isFinishSurvey}, this.step)

      if(this.step < 6) this.step += 1;
    },
    network(){
      return {
        getData:async()=>{
          const {status,data} = await getSurveyQuestion();
          console.log(status,data);
          if(status!==200)return;
          this.disabled = data.data.info.is_save===1;
          for(let i=0;i<data.data.info.list.length;i+=1){
            let item = data.data.info.list[i];
            this.surveyList[i].title = item.name;
            for(let j=0;j<item.answer.length;j+=1){
              this.surveyList[i].options[j].label = item.answer[j].name;
              this.surveyList[i].options[j].id = item.answer[j].id;
            }
          }
        },
        submitData:async(params, step)=>{
          const {status, data} = await submitSurveyData(params);
          if(status!==200)return;
          if(step === 6){
            this.$uihelper.toast('提交成功');
            setTimeout(()=>{ this.nextStep() },1500)
          }
        }
      }
    }
  },
  watch:{
    step(val){

      // 前三个问题是必填
      this.isNeed = val <= 3

    }
  }
};
</script>

<style scoped lang='scss'>
.container {
  display:flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  background: #00d6c5;
  .back-btn {
    position: absolute;
    width: 0.25rem;
    height: 0.44rem;
    left:0.48rem;
    top:0.85rem;
  }
  .pass-btn {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0.85rem;
    right: 0.52rem;
    span {
      margin-right: 0.13rem;
      font-size: 0.29rem;
      color: #fff;
    }
    img {
      width: 0.3rem;
      height: 0.25rem;
      margin-top: 0.02rem;
    }
  }
  .step-block {
    padding: 2.15rem 0 0.38rem 0.72rem;
    .step {
      display: flex;
      width: 2.5rem;
      height: 0.04rem;
      border-radius: 0.02rem;
      background: #82fff5;
      overflow: hidden;
      .content {
        background: #fff;
        transition: all 0.5s linear;
      }
    }
  }
  .block {
    z-index: 100;
    position: relative;
    .title {
      padding-left: 0.7rem;
      font-size: 0.5rem;
      color: #fff;
      margin-bottom: 0.2rem;
      .title-tip{
        font-size: 0.24rem;
      }
    }
    .sub-title {
      padding-left: 0.7rem;
      font-size: 0.24rem;
      color: #fff;
    }
    .options-block {
      padding: 0.58rem 0 0;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .item{
        display: flex;
        box-sizing: border-box;
        justify-content: center;
        align-items:center;
        flex-wrap:wrap;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 50%;
        &.active {
          color: #00d6c5;
          background: #fff;
          border: none;
        }
        .icon-box{
          display:flex;
          width:100%;
          justify-content: center;
          align-items:flex-end;
          .icon{
            max-height:0.44rem;
            margin-bottom:0.1rem;
          }
        }
        span {
          width: 0.56rem;
          line-height: 0.35rem;
          text-align:center;

        }
      }
    }
    .options-block-1 {
      margin: .7rem 0 2.3rem 0;
      font-size: .4rem;
      .item {
        width: 2.2rem;
        height: 2.2rem;
        margin: 0 .4rem 0.31rem;
        span{
          width: 1rem;
          line-height: .45rem;
        }
      }
    }
    .options-block-2{
      display:block;
      position:relative;
      height:5.83rem;
      .item{
        position:absolute;
        &:first-child{
          width:1.64rem;
          height:1.64rem;
          top:0.38rem;
          left:1.7rem;
          font-size:0.34rem;
        }
        &:nth-child(2){
          width:1.23rem;
          height:1.23rem;
          top:0.34rem;
          left:3.66rem;
          font-size:0.26rem;
        }
        &:nth-child(3){
          width:1.06rem;
          height:1.06rem;
          top:0.63rem;
          left:5.26rem;
          font-size:0.24rem;
        }
        &:nth-child(4){
          width:1.56rem;
          height:1.56rem;
          top:2.05rem;
          left:0.83rem;
          font-size:0.32rem;
        }
        &:nth-child(5){
          width:1.85rem;
          height:1.85rem;
          top:1.7rem;
          left:3.06rem;
          font-size:0.4rem;
        }
        &:nth-child(6){
          width:1.32rem;
          height:1.32rem;
          top:1.82rem;
          left:5.26rem;
          font-size:0.28rem;
        }
        &:nth-child(7){
          width:1.32rem;
          height:1.32rem;
          top:4.15rem;
          left:0.89rem;
          font-size:0.26rem;
        }
        &:nth-child(8){
          width:1.17rem;
          height:1.17rem;
          top:3.2rem;
          left:2.14rem;
          font-size:0.26rem;
        }
        &:nth-child(9){
          width:1.1rem;
          height:1.1rem;
          top:4.13rem;
          left:3.28rem;
          font-size:0.24rem;
        }
        &:nth-child(10){
          width:1.85rem;
          height:1.85rem;
          top:3.21rem;
          left:4.47rem;
          font-size:0.38rem;
        }
        span{
          width:100%;
        }
      }
    }
    .options-block-3 {
      .item {
        width: 1.42rem;
        height: 1.42rem;
        margin: 0 0.06rem 0.21rem;
        font-size: .265rem;
      }
    }
    .options-block-4,.options-block-5{
      .item{
        width: 1.99rem;
        height: 1.99rem;
        margin: 0 0.37rem 0.13rem;
        align-items:stretch;
        font-size: .265rem;
      }
    }
    .options-block-6{
      display:block;
      position:relative;
      height:5.83rem;
      .item{
        position:absolute;
        width:1.99rem;
        height:1.99rem;
        align-items:stretch;
        &:first-child{
          top:0.45rem;
          left:50%;
          transform:translate(-50%,0);
        }
        &:nth-child(2){
          top:1.82rem;
          left:0.9rem;
        }
        &:nth-child(3){
          top:1.82rem;
          right:0.9rem;
        }
        &:last-child{
          top:3.25rem;
          left:50%;
          transform:translate(-50%,0);
        }
        span {
          width: 0.98rem;
        }
      }
    }
  }
  .back-block{
    position:relative;
    flex-grow:1;
    min-height:4.2rem;
      .next-btn {
        position: absolute;
        width: 2.67rem;
        height: 0.7rem;
        right: 0.52rem;
        top:0.2rem;
        z-index:110;
      }
    .back-img {
      z-index: 50;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .back-img-1{
      width:100%;
    }
    .back-img-2{
      width:100%;
    }
    .back-img-3 {
      width: 5.07rem;
    }
    .back-img-4 {
      width: 100%;
    }
    .back-img-5 {
      width: 7.04rem;
    }

    .back-img-6 {
      width: 6.65rem;
    }

  }
}
</style>
